export type AppUpdateType = 'none' | 'optional' | 'critical';
export type AppUpdatePlatform = 'ios' | 'android';

export interface AppUpdateSetting {
  platform: AppUpdatePlatform;
  latest_version: string;
  update_type: AppUpdateType;
  title: string | null;
  message: string | null;
  store_url: string | null;
  update_available?: boolean;
  force_update?: boolean;
}

export function compareAppVersions(left: string, right: string): number {
  const leftParts = versionParts(left);
  const rightParts = versionParts(right);
  const length = Math.max(leftParts.length, rightParts.length);

  for (let i = 0; i < length; i++) {
    const leftValue = leftParts[i] ?? 0;
    const rightValue = rightParts[i] ?? 0;
    if (leftValue > rightValue) return 1;
    if (leftValue < rightValue) return -1;
  }

  return 0;
}

export function isOlderAppVersion(current: string, latest: string): boolean {
  return compareAppVersions(current, latest) < 0;
}

export function dismissedUpdateStorageKey(
  platform: AppUpdatePlatform,
  latestVersion: string,
): string {
  return `dismissedAppUpdate:${platform}:${latestVersion}`;
}

function versionParts(version: string): number[] {
  const normalized = String(version || '')
    .toLowerCase()
    .replace(/[^0-9.]+/g, '.')
    .replace(/^\.+|\.+$/g, '');

  if (!normalized) {
    return [0];
  }

  return normalized.split('.').map((part) => parseInt(part, 10) || 0);
}
